import React, { useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { PublicHeader } from '@/components/public/PublicHeader';
import { useAuth } from '@/state/auth/AuthProvider';
import { useLanguage } from '@/state/language/LanguageProvider';

/**
 * Public pricing is deferred until after signup.
 * Guests are sent home; signed-in users go to in-app subscription screens.
 */
export const PricingPage: React.FC = () => {
  const { t } = useLanguage();
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthenticated) return;
    navigate('/settings/profile?section=subscription', { replace: true });
  }, [isAuthenticated, navigate]);

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col">
      <PublicHeader />
      <main className="flex-1 flex items-center justify-center px-4 py-12">
        <p className="text-sm text-gray-600">{t('common.loading') || 'Loading…'}</p>
      </main>
    </div>
  );
};
